
var isActive = false;

$("#hamburger-item").click(
    function(){
        $(".navigation-bar-sublist").toggleClass("active");
        $("body").toggleClass("active");
        $("#hamburger-item>.fa-bars").css("backgroundImage");
        $('#navigation-home-item').toggleClass('menu-is-active');
        $('#lang-selection-button').toggleClass('menu-is-active');        
})


document.documentElement.style.setProperty('--header-height', $("#header").height() + "px");

$(document).ready(function() {
    $("#lang-selection-button").click(
        function(){
            $(".lang-list").toggleClass("active");
        }
    )
});
 